import React from 'react';

import List from '../Components/List';

const someComponent = ({item}) => (
    <div>{item}</div>
);

const About = ({}) => (
    <div className='about page'>
        <h2>
            Hello
        </h2>
        <br></br>
        <p>My name is Devjeet Roy and I'm a first year PhD student at the Washington State University
        under <a className='link' href='https://www.veneraarnaoudova.com/'>Dr. Venera Arnaoudova</a>. 
        </p>
        <br></br>
        <p>  My research area 
        is empirical software engineering, and I'm working with my colleagues at the Software Engineering Lab
        at WSU to study the effect of certain programming practices and language features on developers 
        using brain imaging and eyetracking. 
        </p>
    </div>
);


export default About;